import type {
  IAdditionalSettings,
  IAdditionalSettingsPayload
} from '@/interfaces/agency/settings/agency/additional-settings/index';
import axios from '@axios';

export default {
  async fetchAdditionalDetails() {
    return await axios.get<IAdditionalSettings[]>(`agency-settings`);
  },

  async updateAdditionalDetails(id: number, payload: IAdditionalSettingsPayload) {
    return await axios.patch(`/agency-settings/${id}`, payload);
  }
};
